import { getTimeZoneOffset } from '../../helpers/utility';

const getMTDRepossessedAPI = (dateStart, dateEnd, timezoneOffset) =>
  `api/reports/repossessed?dateStart=${dateStart}&dateEnd=${dateEnd}&timezoneOffset=${timezoneOffset}`;

const getMTDMissedRepossessedAPI = (dateStart, dateEnd, timezoneOffset) =>
  `api/stats/missed-repossessions/total?&start=${dateStart}&end=${dateEnd}&timezoneOffset=${timezoneOffset}`;

const getMTDAssignedAPI = (dateStart, dateEnd, timezoneOffset) =>
  `api/reports/assigned?dateStart=${dateStart}&dateEnd=${dateEnd}&timezoneOffset=${timezoneOffset}`;

const getMTDYTDCompanyUncategorizedAPI = (timezoneOffset) =>
  `api/reports/uncategorized/company?timezoneOffset=${timezoneOffset}`;

const getPCYMCompanyStatsAPI = (year, timezoneOffset) =>
  `/api/reports/company-2-years?year=${year}&timezoneOffset=${timezoneOffset}`;

const getYTDCompanyStatsAPI = (currentDay, timezoneOffset) =>
  `/api/reports/company/ytd?currentDay=${currentDay}&timezoneOffset=${timezoneOffset}`;

const getDailyViewStatsAPI = (date, timezoneOffset, branchId) =>
  `/api/reports/daily-report?date=${date}&timezoneOffset=${timezoneOffset}&branchId=${branchId}`;

const getTopAgentsAPI = (dateStart, dateEnd, timezoneOffset) =>
  `api/reports/agents-by-rank?dateStart=${dateStart}&dateEnd=${dateEnd}&timezoneOffset=${timezoneOffset}`;

const getTopSpottersAPI = (dateStart, dateEnd, timezoneOffset) =>
  `api/reports/spotters-by-rank?dateStart=${dateStart}&dateEnd=${dateEnd}&timezoneOffset=${timezoneOffset}`;

const getMTDYTDEmployeesStatsAPI = (mtdStartDate, mtdEndDate, ytdStartDate, ytdEndDate, timezoneOffset) =>
  `/api/reports/employees-stats-by-rank?mtdStartDate=${mtdStartDate}&mtdEndDate=${mtdEndDate}&ytdStartDate=${ytdStartDate}&ytdEndDate=${ytdEndDate}&timezoneOffset=${timezoneOffset}`;

const getMTDYTDClientUncategorizedAPI = (clientId, timezoneOffset) =>
  `api/reports/uncategorized/client?clientId=${clientId}&timezoneOffset=${timezoneOffset}`;

const getYTDClientStatsAPI = (clientId, timezoneOffset) =>
  `api/reports/client/ytd?clientId=${clientId}&timezoneOffset=${timezoneOffset}`;

const getMTDPastYearsClientStatsAPI = (clientId, timezoneOffset, currentDay) =>
  `api/reports/client-past-3-years-mtd?clientId=${clientId}&timezoneOffset=${timezoneOffset}&currentDay=${currentDay}`;

const getDailyEmployeesShiftAPI = (date, timezoneOffset) =>
  `api/reports/employee/daily?date=${date}&timezoneOffset=${timezoneOffset}`;

const getWeeklyEmployeesShiftAPI = (startDate, endDate, timezoneOffset) =>
  `api/reports/employee/weekly?start=${startDate}&end=${endDate}&timezoneOffset=${timezoneOffset}`;

const getDailyMapAPI = (date, activeBranchId) => `api/reports/daily-map?date=${date}&branchId=${activeBranchId}`;

const sendWeeklyRepossessionsReportNowAPI = () => '/api/reports/weekly-repossessions-report/send-now';

const detailsDailyMap = {
  getAssignedCaseClientListAPI: (branchId, date) =>
    `api/reports/assigned-client-list?branchId=${branchId}&date=${date}`,
  getSpottedCaseClientListAPI: (branchId, date, timezoneOffset) =>
    `api/reports/spotted-client-list?branchId=${branchId}&date=${date}&timezoneOffset=${timezoneOffset}`,
  getSpottedNotSecuredCaseClientListAPI: (branchId, date, timezoneOffset) =>
    `api/reports/spotted-not-secured-client-list?branchId=${branchId}&date=${date}&timezoneOffset=${timezoneOffset}`,
  getSpottedCaseAgentListAPI: (branchId, date) =>
    `api/reports/spotted-user-list?branchId=${branchId}&date=${date}&timezoneOffset=${getTimeZoneOffset()}`,
};

const getDriverRepossessionList = ({ id, branchId, startDate, endDate, isVoluntary, isInVoluntary, isImpound }) =>
  `api/reports/repossessed-list/${id}?branchId=${branchId}&startDate=${startDate}&endDate=${endDate}&isVoluntary=${isVoluntary}&isInVoluntary=${isInVoluntary}&isImpound=${isImpound}`;

const getDriverSpottedList = ({ id, branchId, startDate, endDate, secured, closed, openAndNeedInfo }) =>
  `api/reports/spotted-list/${id}?branchId=${branchId}&startDate=${startDate}&endDate=${endDate}&secured=${secured}&closed=${closed}&openAndNeedInfo=${openAndNeedInfo}`;

export const reportsEndpoints = {
  detailsDailyMap,
  getMTDRepossessedAPI,
  getMTDMissedRepossessedAPI,
  getMTDAssignedAPI,
  getMTDYTDCompanyUncategorizedAPI,
  getPCYMCompanyStatsAPI,
  getYTDCompanyStatsAPI,
  getTopAgentsAPI,
  getTopSpottersAPI,
  getMTDYTDEmployeesStatsAPI,
  getMTDYTDClientUncategorizedAPI,
  getYTDClientStatsAPI,
  getMTDPastYearsClientStatsAPI,
  getDailyEmployeesShiftAPI,
  getWeeklyEmployeesShiftAPI,
  getDailyViewStatsAPI,
  getMissedRepossessionsAPI: (branchId = 0, start = '2021-01-01', end = '2021-12-31', timezoneOffset = -5.5) =>
    `/api/stats/missed-repossessions/details?branchId=${branchId}&start=${start}&end=${end}&timezoneOffset=${timezoneOffset}`,
  getTotalRepossessionsAPI: (branchId = 0, start = '2021-01-01', end = '2021-12-31', timezoneOffset = -5.5) =>
    `/api/stats/repossessed-client-list?branchId=${branchId}&start=${start}&end=${end}&timezoneOffset=${timezoneOffset}`,
  getTotalAssignmentsAPI: (branchId = 0, start = '2021-01-01', end = '2021-12-31', timezoneOffset = -5.5) =>
    `/api/stats/assigned-client-list?branchId=${branchId}&start=${start}&end=${end}&timezoneOffset=${timezoneOffset}`,
  getDailyMapAPI,
  getDriverRepossessionList,
  getDriverSpottedList,
  sendWeeklyRepossessionsReportNowAPI,
  sendCloudLogs: () => '/api/cloud-logger/add?groupName=rra-dashboard',
};
